import { TechInsightsOverviewPage } from '@internal/plugin-tech-insights-overview'
import {
  EntityLifecyclePicker,
  EntityTagPicker,
  EntityTypePicker
} from '@backstage/plugin-catalog-react'
import { EntityFailedChecksPicker } from '../catalog-index/EntityFailedChecksPicker'
import { EntityPassedChecksPicker } from '../catalog-index/EntityPassedChecksPicker'
import { EntityBaPodPicker } from '../catalog-index/EntityBaPodPicker'
import { CustomEntityKindPicker } from '../catalog-index/CustomEntityKindPicker'

const filters = (
  <>
    <CustomEntityKindPicker />
    <EntityTypePicker />
    <EntityBaPodPicker />
    <EntityFailedChecksPicker />
    <EntityPassedChecksPicker />
    <EntityLifecyclePicker />
    <EntityTagPicker />
  </>
)

export const techInsightsOverviewPage = (
  <TechInsightsOverviewPage
    title="Scorecards"
    subtitle="Tech Insights Overview"
    filters={filters}
  />
)
